import { IEquipmentWithoutProduct } from '@models/Equipment.model';
import {
  equipmentFieldNameDictionary,
  IFieldConfiguration,
} from '@models/FieldConfiguration.model';
import { getEquipmentValue } from '@utils/index';
import { FieldContent } from './Data.styles';
import { LabelMenu } from './LabelMenu';
import { IDataItem } from './types';

type FieldWithName = Pick<IFieldConfiguration, 'name' | 'fieldName'>;

interface DataItemProps {
  item: IDataItem;
  equipment: IEquipmentWithoutProduct;
  config: FieldWithName[];
}
export function DataItem(props: DataItemProps) {
  const { item, equipment, config } = props;
  const { fieldName, customName, formatter } = item;
  const dictionaryName = equipmentFieldNameDictionary[fieldName];
  let label = dictionaryName;
  let value: React.ReactNode = getEquipmentValue(item, equipment);
  if (customName) label = customName;
  if (formatter) value = formatter(equipment[fieldName], { equipment });

  const pinned = config.some(configItem => {
    // Only this pair is unique for internal data.
    const sameFieldName = configItem.fieldName === item.fieldName;
    return sameFieldName;
  });
  return (
    <LabelMenu label={label} pinned={pinned} fieldName={fieldName}>
      <FieldContent className="new-icon" empty={!value}>
        {value || 'Empty'}
      </FieldContent>
    </LabelMenu>
  );
}
